import styled from 'styled-components';

import theme from './theme';

export const SelectedOption = styled.div`
  color: ${theme.selectedOptionColor};
  margin-right: 20px;

  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 160px;

  ${Styles.desktop`
    max-width: 300px;
  `}
`;
